import axios from 'axios';
import Api from '../api';
import type {
  TestingReport,
  CreateTestingReportResponse,
  ConfirmTestingReportResponse,
} from '../Types/testing-report';

type CreateTestingReportParams = {
  userId: string;
  poNumber: string;
  fileName: string;
  fileSize: number;
};

type ConfirmTestingReportParams = {
  userId: string;
  poNumber: string;
  reportId: string;
};

type UploadFileToS3Params = {
  uploadUrl: string;
  file: File;
  onProgress?: (progress: number) => void;
};

type GetTestingReportsResponse = {
  testing_reports: TestingReport[];
};

const TestingReportsAPI = {
  async getTestingReports(
    userId: string,
    poNumber: string,
  ): Promise<TestingReport[]> {
    const response = (await Api.get(
      `/users/${userId}/purchase-orders/${poNumber}/testing-reports`,
    )) as GetTestingReportsResponse;
    return response.testing_reports || [];
  },

  async createTestingReport(
    params: CreateTestingReportParams,
  ): Promise<CreateTestingReportResponse> {
    const { userId, poNumber, fileName, fileSize } = params;
    return (await Api.post(
      `/users/${userId}/purchase-orders/${poNumber}/testing-reports`,
      {
        data: {
          file_name: fileName,
          file_size: fileSize,
        },
      },
    )) as CreateTestingReportResponse;
  },

  async confirmTestingReport(
    params: ConfirmTestingReportParams,
  ): Promise<ConfirmTestingReportResponse> {
    const { userId, poNumber, reportId } = params;
    return (await Api.patch(
      `/users/${userId}/purchase-orders/${poNumber}/testing-reports/${reportId}/confirm`,
    )) as ConfirmTestingReportResponse;
  },

  async uploadFileToS3(params: UploadFileToS3Params): Promise<void> {
    const { uploadUrl, file, onProgress } = params;

    await axios.put(uploadUrl, file, {
      headers: { 'Content-Type': 'application/pdf' },
      timeout: 120000,
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          onProgress(
            Math.round((progressEvent.loaded * 100) / progressEvent.total),
          );
        }
      },
    });
  },
};

export default TestingReportsAPI;
